//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import UpgardeRequired from "../pages/UpgardeRequired";





/**
 * Top level application router
 *
 * @returns {JSX.Element}
 */
const Router = () => {
  return (
    <Routes>
      <Route path={"/accounting"} element={< UpgardeRequired/>} />
    </Routes>
  );
};

export default Router;
